import u, { forwardRef as y, useState as L, useCallback as M, useMemo as O } from "react";
import { ark as a } from "@ark-ui/react";
import { layout as e } from "@huspy/styled-system/recipes";
import { cx as v, css as f } from "@huspy/styled-system/css";
import { splitCssProps as x } from "@huspy/styled-system/jsx";
import { createStyleContext as R } from "../../../utils/createStyleContext.mjs";
import { LayoutContext as S, useLayoutContext as N } from "../use-layout.mjs";
const { withProvider: g, withContext: P } = R(e), k = g(
  y((r, n) => {
    const { open: o = "none" } = r, [t, s] = L(o), [c, i] = e.splitVariantProps(r), [p, l] = x({ ...i, open: t }), { children: d, className: m, ...h } = l, E = e({ ...c, open: t }), C = M(
      (b) => {
        s((w) => w === b ? "none" : b);
      },
      [s]
    ), V = O(
      () => ({ open: t, toggle: C, setOpen: s }),
      [t, C]
    );
    return /* @__PURE__ */ u.createElement(S.Provider, { value: V }, /* @__PURE__ */ u.createElement(a.div, { ref: n, className: v(E.root, f(p), m), ...h }, d));
  }),
  "root"
), A = P(
  a.div,
  "header"
), H = P(
  a.main,
  "content"
), I = P(
  y(
    (r, n) => {
      const { open: o } = N(), [t, s] = e.splitVariantProps(r), [c, i] = x({ ...s, open: o }), { children: p, className: l, ...d } = i, m = e({ ...t, open: o });
      return /* @__PURE__ */ u.createElement(
        a.aside,
        {
          ref: n,
          className: v(m.sidebar, f(c), l),
          "data-open": o === "sidebar",
          "data-testid": "sidebar",
          ...d
        },
        p
      );
    }
  ),
  "sidebar"
), j = P(
  y(
    (r, n) => {
      const { open: o } = N(), [t, s] = e.splitVariantProps(r), [c, i] = x({ ...s, open: o }), { children: p, className: l, ...d } = i, m = e({ ...t, open: o });
      return /* @__PURE__ */ u.createElement(
        a.aside,
        {
          "data-open": o === "aside",
          "data-testid": "aside",
          ref: n,
          className: v(m.aside, f(c), l),
          ...d
        },
        p
      );
    }
  ),
  "aside"
), q = P(
  a.div,
  "asideMenu"
), Q = {
  Root: k,
  Header: A,
  Content: H,
  Sidebar: I,
  Aside: j,
  AsideMenu: q
};
export {
  Q as Layout
};
